import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";

import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingEnquiryButton from "./components/FloatingEnquiryButton";

// Pages
import Home from "./components/Home";
import AboutUs from "./components/AboutUs";
import Academics from "./components/Academics";
import MiddleAcademics from "./components/MiddleAcademics";
import SeniorSecondaryAcademics from "./components/SeniorSecondaryAcademics";
import Admissions from "./components/Admissions";
import Interview from "./components/interview"; // corrected case
import Facilities from "./components/Facilities";
import ContactUs from "./components/ContactUs";
import Gallery from "./components/Gallery";
import Careers from "./components/Careers";
import ProtectedAdmin from "./components/ProtectedAdmin";

// Layout wrapper for main website
function MainLayout() {
  return (
    <div className="bg-background-light dark:bg-background-dark font-display text-slate-800 dark:text-slate-200">
      <Header />

      <div className="relative min-h-screen w-full flex-col overflow-x-hidden">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/academics" element={<Academics />} />
          <Route path="/middle-academics" element={<MiddleAcademics />} />
          <Route path="/senior-secondary-academics" element={<SeniorSecondaryAcademics />} />
          <Route path="/admissions" element={<Admissions />} />
          <Route path="/interview" element={<Interview />} /> {/* added route */}
          <Route path="/facilities" element={<Facilities />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/careers" element={<Careers />} />
        </Routes>

        <Footer />
        <FloatingEnquiryButton />
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Admin routes (without Header/Footer) */}
        <Route path="/admin/*" element={<ProtectedAdmin />} />

        {/* Main website routes */}
        <Route path="/*" element={<MainLayout />} />
      </Routes>

      {/* Vercel Analytics & Speed Insights */}
      <Analytics />
      <SpeedInsights />
    </Router>
  );
}

export default App;
